import { createSelector } from 'reselect';
import { get } from 'lodash-es';
import { channelsSelector, integrationSelector } from 'common/selectors';
import { FIELDS } from 'components/forms';

export const getUploadProgressSelector = createSelector(
  (state) => state.upload.videoUploadProgress,
  (uploadProgress) => Number(uploadProgress)
);

export const getVideoIsPublishedSelector = createSelector(
  (state) => state.upload.videoIsPublished,
  (videoIsPublished) => videoIsPublished
);

export const getSkipSelectVideoSelector = createSelector(
  (state) => state.upload.skipSelectVideo,
  (skipSelectVideo) => skipSelectVideo
);

export const getUploadVideoObjectSelector = createSelector(
  (state) => state.upload.videoInitObject,
  (uploadVideoObject) => uploadVideoObject
);

export const getUploadVideoIsUnsupportedSelector = createSelector(
  (state) => state.upload.videoIsUnsupported,
  (videoIsUnsupported) => videoIsUnsupported
);

export const uploadedVideoSelector = createSelector(
  [getUploadVideoObjectSelector, channelsSelector, integrationSelector],
  (uploadedVideo, channels, integration) =>
    uploadedVideo
      ? uploadedVideo.video.channels.map((channel) => {
          const channelId = channel['id'];
          const channelEntity = channels.find((channel) => channel.id === channelId);

          const slug = get(channelEntity, 'slug', 'slug');
          const channelName = get(channelEntity, 'name');
          const videoId = uploadedVideo.video.id;

          return {
            url: `${integration.baseUrl}/channel/${channelId}/${slug}/1/${videoId}`,
            channelName,
          };
        })
      : []
);

export const uploadFormConfigSelector = createSelector(
  (state) => state.upload.uploadFormConfig,
  (uploadFormConfig) => uploadFormConfig
);

export const uploadFailedSelector = createSelector(
  (state) => state.upload.uploadFailed,
  (failed) => failed
);

export const initialValuesSelector = createSelector(
  [uploadFormConfigSelector, getUploadVideoObjectSelector],
  (uploadFormConfig, videoInitObject) => {
    const data = {
      title: videoInitObject?.title,
    };
    if (uploadFormConfig) {
      uploadFormConfig.forEach((cfg, index) => {
        if (cfg.type === FIELDS.CHANNEL_SELECT) {
          data[`${FIELDS.CHANNEL_SELECT}_${index}`] = null;
        }
      });
    }
    return data;
  }
);
